export default __webpack_public_path__ + "static/media/rnr-sports-table-9.f599644b.webp";